<div class="col-sm-12 detail" style="height: 100%" *ngIf="!isEdit && !isEmpty" (click)="common.outSide($event)">
	<div class="header col-sm-12">
		<div class="col-sm-8">
			<h2> Liste des montants TEOM </h2>
		</div>
		<div class="col-sm-4 text-right">
			<button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
			<!--
        <button class="btn-header uppercase actionPricipal" id="valide" (click)="valide()"> Valider </button>
        -->
		</div>
	</div>

	<div class="col-sm-12 ligneBon liste">
		<ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listMontantsTeom || []"
			[columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="auto"  [selectionType]="'checkbox'"
			[messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator">
			<ngx-datatable-column prop="annee" [width]="60">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Année </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
					<span> {{value}} </span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column [width]="150" prop = "libelleLieu">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Lieu </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
					<span>
            {{ row.chantier && row.chantier.numChantier2 ? row.chantier.numChantier2  +'/' : '' }}  	{{ row.chantier && row.chantier.numChantier ? row.chantier.numChantier : '' }} {{row.chantier ? (row.chantier.responsable ?
						'/ ' +row.chantier.responsable : '') :
						''}}
						{{row.chantier ? (row.chantier.adresse1 ? ' / ' + row.chantier.adresse1 : '') : ''}}
						{{row.chantier ? (row.chantier.ville ? '/ ' + row.chantier.ville : '') : ''}}
					</span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column prop="valeur" [width]="120">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Montant restant </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
					<div style="text-align: left" style="margin-left: 15px;" >{{ value }} €</div>
				</ng-template>
			</ngx-datatable-column>

      <ngx-datatable-column prop="valeurInitiale" [width]="100">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Montant </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
					<div style="text-align: left"  style="margin-left: 15px;">{{ value }} €</div>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column prop="doc" [width]="170">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Justificatif </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="col-sm-12" *ngIf="row.doc">
            <a href="{{ urlecoportail }}/DownloadDocTeom?filename={{ value }}" target="__BLANK">{{ row.doc || '' }}</a>
          </div>
          <div class="col-sm-12" *ngIf="row.doc2">
            <a href="{{ urlecoportail }}/DownloadDocTeom?filename={{ row.doc2 }}" target="__BLANK">{{ row.doc2 }}</a>
          </div>
          <div class="col-sm-12" *ngIf="row.doc3">
            <a href="{{ urlecoportail }}/DownloadDocTeom?filename={{ row.doc3 }}" target="__BLANK">{{ row.doc3 }}</a>
          </div>
          <div class="col-sm-12" *ngIf="row.doc4">
            <a href="{{ urlecoportail }}/DownloadDocTeom?filename={{ row.doc4 }}" target="__BLANK">{{ row.doc4 }}</a> 
          </div>
				</ng-template>
			</ngx-datatable-column>

      <ngx-datatable-column prop="dateCreation"[width]="100">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Date création </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
					<span>{{ value ? value.slice(0, -9) : '01/01/2000' }}</span>
				</ng-template>
			</ngx-datatable-column>


			<ngx-datatable-column prop="dateValidation"[width]="100">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Date Validation</span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
					<span>{{ value ? value.slice(0, -9) : '' }}</span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column [width]="160" prop = "nomUserValidation">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Utilisateur validation </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
					<span> {{ (row.nomUserValidation ? row.nomUserValidation : '') + ' ' + (row.prenomUserValidation ?
						row.prenomUserValidation : '') }} </span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column [width]="70"  prop="valide"  [canAutoResize]="false" [draggable]="false"
				[resizeable]="false">
				<ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
					let-sort="sortFn">
					<div class="tableheader" (click)="sort()">
						<span class="uppercase"> Valider </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
					</div>
				</ng-template>
				<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
					<div class="text-center">
						<button class="btn-detail save" (click)="confirmationValide(row)" *ngIf="!row.valide">
							<i class="fa fa-check" aria-hidden="true"></i>
						</button>
					</div>
				</ng-template>
			</ngx-datatable-column>

      <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
      [resizeable]="false">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
          <div class="text-center">
              <button class="btn-detail" (click)="showFormEdit(row);" *ngIf="!row.valide">
                  <i class="fa fa-pencil"></i>
              </button>&nbsp;
              <button class="btn-detail" (click)="deleteLigneConfirmation(row)" *ngIf="!row.valide">
                  <i class="fa fa-trash"></i>
              </button>                            
          </div>
      </ng-template>
  </ngx-datatable-column>

		</ngx-datatable>
	</div>

	<div class="addLigne col-sm-12 uppercase">
		<div class="col-sm-7 text-left">
				<!--button class="btn-add" id="addLigne" (click)="selectedRow = {}; common.openModal(modalService, formEdit)">
					<i class="fa fa-plus"></i>
				</button>
				<span (click)="selectedRow = {}; common.openModal(modalService, formEdit)">Ajouter une ligne</span-->
				<button class="btn-add" id="addLigne" (click)="showFormEdit({})">
						<i class="fa fa-plus"></i>
				</button>
				<span (click)="showFormEdit({})">Ajouter une TEOM</span>

		</div>
		<label class="text-left uppercase text-underline historique col-sm-5"></label>
</div>  

</div>

<div class="col-sm-12 contente-zone" style="padding: 15px 0; height: 100%;" *ngIf="isEdit"  #formEdit (click)="common.outSide($event)">
	<div class="modal-header col-sm-12" style="padding: 5px;" (click)="common.outSide($event)">
			<h4 class="modal-title pull-left col-sm-8"> {{selectedRow.id ? 'Modifier une TEOM' : 'Ajout d\'une TEOM'}} </h4>
			<div class="col-sm-4 text-right">
					<button type="button" class="btn-header uppercase" (click)="error = '';selectedRow = {};justificatifs = [];isEdit = false;"> Fermer
					</button>&nbsp;
					<button type="button" class="btn-header uppercase actionPricipal" (click)="validerFormEdit();">
							Valider </button>
			</div>
	</div>
	<div class="modalFicheClient mt-2 col-sm-12">
			<div class="col-sm-12">
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
                Date de création
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px; position: relative" [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
              <app-input-date [class]="'form-control'" [id]="'dateFss'" [dateVide] = "true" [model]="selectedRow.dateCreationModel"
                  (changefct)="selectedRow.dateCreationModel = $event; changeDateCreation($event, selectedRow);"
                  [placeholder]="'Date debut'" [container] = "true"
                  (keyenterfct)="common.changeDate($event, selectedRow.dateCreationModel, '#valeur'); " [showDatepicker]="true"
                  [position]="'top-left'" [closeDatepickerOnSelect]="true"></app-input-date>
            </div>
          </div>
					<div class="form-group items col-sm-12">
							<label class="col-sm-3 champ" style="padding:0px">
									Année :
							</label>
							<div class="col-sm-9 champ" style="padding-right: 0px">
									<select class="form-control select" name="site" [(ngModel)]="selectedRow.annee">
											<option *ngFor="let item of listAnnee" [ngValue]="item"> {{ item }} </option>
									</select>                 
							</div>
					</div>
					<div class="form-group items col-sm-12">
							<label class="col-sm-3 champ" style="padding:0px">
									Chantier :
							</label>
							<div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
									 <app-autocomplete   [placeholder]="'Chantier'" (searchfunction)="searchChantier($event)"
											(selectfunction)="selectedRow.chantier = $event;" [disablefocus]="true" [results]="listChantier" [showonclick]="true"  [defaultselected]="selectedRow.chantier" 
											[label]="''" id="modedepaie" [defaultsearch]="selectedRow.chantier ? (selectedRow.chantier.numChantier || selectedRow.chantier.responsable || selectedRow.chantier.libelleObjetEntite) : ''"
											[dropdownclass]="'dropDownPrixNego'" ></app-autocomplete>
									 <div *ngIf="leClientA1chantier">
											 {{ selectedRow.chantier.numChantier || selectedRow.chantier.responsable || selectedRow.chantier.libelleObjetEntite }}
									 </div>
							</div>
					</div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
                Montant restant :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
                <input type="number" class="form-control" [(ngModel)]="selectedRow.valeur" (ngModelChange)="changeMontant(selectedRow)">
            </div>
          </div>
        <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
                Montant :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
                <input type="number" class="form-control" [disabled] = "selectedRow && !selectedRow.id" [(ngModel)]="selectedRow.valeurInitiale">
            </div>
        </div> 
          
					<div class="form-group items col-sm-12">
							<label class="col-sm-3 champ" style="padding:0px">
									Justificatif :
							</label>
							<div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
									<!-- <div class="col-sm-3" style="height: 80px; /* width: 80px; */ padding: 5px;" *ngIf="selectedRow.justificatif && selectedRow.justificatif.nomFichier">
											<span>{{ selectedRow.justificatif.nomFichier }}</span>
									</div> -->

									  <div class="col-sm-3 " style="height: 70px; padding: 5px; position: relative;"
                    *ngFor="let file of selectedRow.justificatifs || [] ; let i = index">
                    <div class="pieceJustif">
                      <a href="{{ file.url }}" target="_blank">{{ file.nomFichier }}</a>
                      <button type="button" class="iconTraash" (click)="removeJustificatif(i,file,selectedRow)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
							                    
									<div class="col-sm-5" style="height: 80px; width: 80px; padding: 5px; margin-top: -5px" *ngIf="selectedRow.justificatifs && selectedRow.justificatifs.length < 4">
											<label class="thumbnail text-center" for="input-file-justificatif"
													style="margin: 0; height: 100%; font-size: 11px;">
													<input class="hide" id="input-file-justificatif"   (change)="getNameFile($event,selectedRow)" type="file"  accept="{{ common.extFichierImgEtTexte }}"  />
													<i class="fa fa-upload"></i>
													<div>Charger un document</div>
											</label>
									</div>
							</div>
					</div>               
			</div>
	</div>
</div>


<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

<ng-template #confirme>
	<div class="modal-header">
		<h4 class="modal-title pull-left"> Confirmation </h4>
		<button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" style="height: auto">
		<div>
			<div class="col-sm-12">
				<label class="cofirmemsg"> Etes vous sur de vouloir valider la TEOM de {{ ligneAValider.valeur }} euro pour
					l'année {{ ligneAValider.annee }} {{ ligneAValider.chantier && ligneAValider.chantier.numChantier ? (' et ' + ligneAValider.chantier.numChantier) : '' }} ? </label>
			</div>
		</div>
		<div class="text-right" style="margin-top: 15px;">
			<button type="button" class=" btn-close btn-valider" (click)="valide()"> OUI </button>
			<button type="button" class=" btn-close" (click)="common.closeModal()"> NON </button>
		</div>
	</div>
</ng-template>

<ng-template #msg>
	<div class="modal-body" style="height: auto">
			<div>
					<div class="col-sm-12">
							<label class="cofirmemsg" [innerHTML]="error"> </label>
					</div>
			</div>
			<div class="text-right" style="margin-top: 15px;">
					<button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
			</button>
	</div>
</div>
</ng-template>


<ng-template #confirmeSupp>
  <div class="modal-header">
      <h4 class="modal-title pull-left"> Confirmation : </h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
          <span aria-hidden="true">&times;</span>
      </button>
  </div>
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <label class="cofirmemsg"> Voulez vous supprimer cette TEOM ? </label>
          </div>
      </div>
      <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
          <button type="button" class="btn-close btn-valider" (click)="common.closeModal(); deleteLigne()"> OUI
          </button>
          <button type="button" class="btn-close btn-non" (click)="common.closeModal();"> NON </button>
      </div>
  </div>
</ng-template>